/* eslint-disable react/prop-types */
import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "../../../components/CustomButtons/Button";
import ModalHeader from "../../../components/ModalHeader";

export default function ResetInputsDialog({
  open,
  onClose,
  onConfirm,
  disableActions,
  classes,
  Transition,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
      fullWidth
      maxWidth={"sm"}
    >
      <ModalHeader
        id="content-modal-slide-title"
        title={t("modeling_inputs_v2.restart_month")}
        subtitle={t("modeling_inputs_v2.modals.restart_inputs.header_subtitle")}
        pills={[
          {
            key: "warning",
            label: t("modeling_inputs_v2.modals.restart_inputs.warning_pill"),
            tone: "error",
            dot: true,
          },
        ]}
        onClose={onClose}
        closeDisabled={disableActions}
        closeLabel={t("modeling_inputs_v2.drawer.close", "Fechar")}
      />
      <DialogContent
        id="classic-modal-slide-description"
        className={classes.modalBody}
      >
        <div style={{ marginBottom: "16px" }}>
          {t("modeling_inputs_v2.modals.restart_inputs.notice")}
        </div>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={onClose}
          color="black"
          simple
          disabled={disableActions}
        >
          {t("modeling_inputs_v2.modals.restart_inputs.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="danger"
          simple
          disabled={disableActions}
        >
          {t("modeling_inputs_v2.modals.restart_inputs.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
